/**
 * Created by Slava on 04.06.2024
 */

Offers.initialize = cleverapps.extendFunc(Offers.initialize, function () {
    if (cleverapps.config.features.includes("kingscup")
        && cleverapps.config.features.includes("offers")) {
        Offers[Offers.TYPES.KINGSCUP] = {
            mission: Mission.TYPE_KINGSCUP,
            product: "kit3",
            view: OfferWindow,
            bundle: "offer_0",
            reward: RewardsConfig.KingsCupOffer,
            sideBarJson: bundles.sidebar.jsons.kingscup_offer_json,
            name: "KingsCupOffer",
            duration: "24 hours",
            cooldown: "24 hours",
            pendingWindow: true
        };
    }

    if (cleverapps.config.features.includes("lighting_rush")
        && cleverapps.config.features.includes("offers")) {
        Offers.TYPES.LIGHTNING_RUSH = 101;
        Offers[Offers.TYPES.LIGHTNING_RUSH] = {
            mission: Mission.TYPE_LIGHTNING_RUSH,
            product: "kit3",
            view: OfferWindow,
            bundle: "offer_1",
            reward: RewardsConfig.LightningRushOffer,
            sideBarJson: bundles.sidebar.jsons.lightning_rush_offer_json,
            name: "LightningRushOffer",
            duration: "24 hours",
            cooldown: "24 hours",
            pendingWindow: true
        };
    }

    if (cleverapps.config.features.includes("revive_offer")) {
        Offers.TYPES.REVIVE_OFFER = 150;
        Offers[Offers.TYPES.REVIVE_OFFER] = {
            name: "ReviveOffer",
            logic: ReviveOfferLogic,
            // the kit per bracket; its contents are RewardsConfig.ReviveKits, the reward follows the product.
            // whales on kit10: kit5 (from 10.10) brought 50% more purchases but 18% less whale revive revenue
            // than kit10 (30.09-08.10, arrowsaway + tapaway)
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit10", "kit10"],
            // replaces the row above where the store sells the product and the player qualifies: veteran
            // non-payers get a 1-dollar entry once the starter packs are behind them. kit1 is listed per game
            // in products.json with the sources that need no store registration, so elsewhere it stays kit3.
            // segmentsolitaire opens it at level 30
            upgradeByPayerLevel: [
                { product: "kit1", available: { actualLevel: cleverapps.config.name === "segmentsolitaire" ? 30 : 50 } }
            ],
            // shown only when hard cannot pay the current continue, see ReviveOfferLogic.isAvailable
            available: cleverapps.config.availables.REVIVE_OFFER,
            noSideBarIcon: true,
            bundle: "reviveoffer"
        };
    }

    if (cleverapps.config.features.includes("pickone_offer")) {
        const rewards = RewardsConfig.PickOneOffer;

        Offers.TYPES.PICK_ONE_OFFER = 170;
        Offers[Offers.TYPES.PICK_ONE_OFFER] = {
            name: "PickOneOffer",
            logic: PickOneOfferLogic,
            isAvailable: PickOneOfferLogic.IsAvailable,
            view: PickOneOfferWindow,
            bundle: "pickone_offer",
            sideBarJson: bundles.sidebar.jsons.pickone_offer_json,
            productByPayerLevel: ["kit7", "kit7", "kit10", "kit10", "kit20"],
            rewardByPayerLevel: [rewards.weak.all, rewards.weak.all, rewards.medium.all, rewards.medium.all, rewards.bigwhale.all],
            packProductByPayerLevel: [
                ["kit1", "kit3", "kit5"],
                ["kit1", "kit3", "kit5"],
                ["kit2", "kit4", "kit8"],
                ["kit2", "kit4", "kit8"],
                ["kit4", "kit8", "kit16"]
            ],
            packRewardByPayerLevel: [rewards.weak.packs, rewards.weak.packs, rewards.medium.packs, rewards.medium.packs, rewards.bigwhale.packs],
            discount: 30,
            schedule: "FRI-MON",
            available: cleverapps.config.availables.PICK_ONE_OFFER,
            inABExperiments: () => cleverapps.abExperiments.getGroup(ABExperiments.Tests.pickoneOn) !== "B",
            pendingWindow: true
        };
    }

    this._super();
});
